import Vue from "vue"
import permission from "./permission"
//注册全局指令
Vue.use(permission)